import React, { useState } from "react";
import { Search } from "lucide-react";

const CompetitorSearch = ({ onSearch }) => {
  const [query, setQuery] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(query);
  };

  return (
    <div className="mb-4">
      <div className="text-center mb-4">
        <h5 className="mb-2">
          Find your <span className="text-danger"> competitors </span>
        </h5>
        <p className="text-muted small">
          We have curated a list of your competitors but if we <br></br>missed
          out on any, you can add them from here
        </p>
      </div>
      <form onSubmit={handleSubmit} className="d-flex justify-content-center">
        <div className="input-group" style={{ maxWidth: "500px" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Enter competitor domain..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button className="btn btn-dark" type="submit">
            <Search size={18} />
          </button>
        </div>
      </form>
      <div className="img d-flex justify-content-center align-items-center mt-4">
        <img
          src="/light-building.svg"
          alt=""
          height={50}
          className="img-fluid"
        />
      </div>
    </div>
  );
};

export default CompetitorSearch;
